import { NonFunctionalPreviewField } from "./NonFunctionPreview";
export const VideoPreview = ({
  type,
  value,
  ...entry
}) => {
  return <div className="video-upload--field">
      <NonFunctionalPreviewField {...entry} type={type} value={value} />
    </div>;
};